import {
    REQUEST_BASE_USER,
    FETCH_BASE_USER_SUCCESS,
    FETCH_BASE_USER_FAILURE,
    REQUEST_BASE_USER_DETAIL,
    FETCH_BASE_USER_DETAIL_SUCCESS,
    FETCH_BASE_USER_DETAIL_FAILURE,
    REQUEST_MOBILE_USERS,
    FETCH_MOBILE_USERS_SUCCESS,
    FETCH_MOBILE_USERS_FAILURE,
    SELECT_CURRENT_USER,
    RESET_CURRENT_USER,
    REQUEST_USER_GROUPS,
    FETCH_USER_GROUPS_SUCCESS,
    FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS,
    FETCH_USER_GROUPS_FAILURE,
    REQUEST_GROUP_DETAIL,
    FETCH_GROUP_DETAIL_SUCCESS,
    FETCH_GROUP_DETAIL_FAILURE,
    SELECT_CURRENT_GROUP,
    RESET_CURRENT_USER_GROUP,
    REQUEST_PERMISSIONS,
    FETCH_PERMISSIONS_SUCCESS,
    FETCH_PERMISSIONS_FAILURE,
    EDIT_USER_DETAIL,
    EDIT_USER_DETAIL_SUCCESS,
    EDIT_USER_DETAIL_FAILURE,
    EDIT_GROUP_DETAIL,
    EDIT_GROUP_DETAIL_SUCCESS,
    EDIT_GROUP_DETAIL_FAILURE,
    RESET_USER_DETAIL,
    CREATE_USER_DETAIL,
    CREATE_USER_DETAIL_SUCCESS,
    CREATE_USER_DETAIL_FAILURE,
    CREATE_GROUP_DETAIL_FAILURE,
    EDIT_PASSWORD,
    EDIT_PASSWORD_SUCCESS,
    EDIT_PASSWORD_FAILURE,
    RESET_PASSWORD,
    CHECK_PASSWORD,
    CHECK_PASSWORD_SUCCESS,
    CHECK_PASSWORD_FAILURE,
    CLEAR_CHECK_PASSWORD,
    CHECK_PERMISSIOIN,
    CHECK_PERMISSIOIN_SUCCESS,
    CHECK_PERMISSIOIN_FAILURE,
    REQUEST_ACTION_LOG,
    FETCH_ACTION_LOG_SUCCESS,
    FETCH_ACTION_LOG_FAILURE,
    REQUEST_ACTION_LOG_BY_FILTER,
    ACTION_LOG_FILTER_SUCCESS,
    ACTION_LOG_FILTER_FAILURE,
    GRAB_MOBILE_USER_ID,
    REQUEST_USERNAME,
    REQUEST_USERNAME_SUCCESS,
    REQUEST_USERNAME_FAILURE,
    CLEAR_USERNAME_DATA,
    SET_SELECTED_BUSINESSUSER,
} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    error: null,
    isLoading: false,
    userDetail: null,
    userDetailError: null,
    userDetailIsLoading: false,
    mobileUsers: [],
    mobileUsersTotalPages: null,
    mobileUsersTotalCount: null,
    mobileUsersIsLoading: false,
    mobileUsersError: null,
    currentUser: null,
    groups: [],
    groupsError: null,
    groupsIsLoading: false,
    groupDetail: null,
    groupDetailError: null,
    groupDetailIsLoading: false,
    currentGroup: null,
    permissions: null,
    permissionsIsLoading: false,
    permissionsError: null,
    editUserDetail: null,
    editUserDetailError: null,
    editUserDetailIsLoading: false,
    editGroupDetail: null,
    editGroupDetailError: null,
    editGroupDetailIsLoading: false,
    editUserDetailSuccess: false,
    editPassword: false,
    editPasswordError: null,
    editPasswordIsLoading: false,
    createUserDetailError: null,
    createGroupDetailError: null,
    checkPassword: false,
    checkPasswordSuccess: false,
    checkPasswordFailure: false,
    checkingPermission: false,
    checkPermissionSuccess: null,
    checkPermissionFailure: false,
    actionLog: [],
    actionLogIsLoading: false,
    actionLogError: null,
    mobileUserId: null,
    username: null,
    usernameIsLoading: false,
    userNameError: null,
    selectedBusinessUser: {},
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
      case SET_SELECTED_BUSINESSUSER:
          return { ...state, selectedBusinessUser: action.payload };
      case REQUEST_BASE_USER:
          return { ...state, error: null, isLoading: true };
      case FETCH_BASE_USER_SUCCESS:
          return { ...state, all: action.payload.data, error: null, isLoading: false };
      case FETCH_BASE_USER_FAILURE:
          const error = action.payload || { message: action.payload.message };
          alert(JSON.stringify(error));
          return { ...state, all: [], error: error, isLoading: false };
      case REQUEST_BASE_USER_DETAIL:
          return { ...state, userDetailError: null, userDetailIsLoading: true, editUserDetailSuccess: false };
      case FETCH_BASE_USER_DETAIL_SUCCESS:
          return { ...state, userDetail: action.payload.data, userDetailError: null, userDetailIsLoading: false };
      case FETCH_BASE_USER_DETAIL_FAILURE:
          const userDetailError = action.payload || { message: action.payload.message };
          return { ...state, userDetail: [], userDetailError: userDetailError, userDetailIsLoading: false };
      case REQUEST_MOBILE_USERS:
          return {
            ...state,
            mobileUsers: [],
            mobileUsersIsLoading: true,
            mobileUsersError: null,
          };
      case FETCH_MOBILE_USERS_SUCCESS:
          return {
            ...state,
            mobileUsers: action.payload.data.record,
            mobileUsersTotalPages: action.payload.data.pages,
            mobileUsersTotalCount: action.payload.data.count,
            mobileUsersIsLoading: false,
            mobileUsersError: null,
          };
      case FETCH_MOBILE_USERS_FAILURE:
          const mobileUsersError = action.payload || { message: action.payload.message };
          alert(JSON.stringify(error));
          return {
            ...state,
            mobileUsers: [],
            mobileUsersIsLoading: false,
            mobileUsersError,
          };
      case SELECT_CURRENT_USER:
          return {...state, currentUser: action.payload};
      case RESET_CURRENT_USER:
          return {...state, currentUser: null, userDetail: null, editUserDetailSuccess: false};
      case REQUEST_USER_GROUPS:
          return { ...state, groupsError: null, groupsIsLoading: true };
      case FETCH_USER_GROUPS_SUCCESS:
          return { ...state, groups: action.payload.data, groupsError: null, groupsIsLoading: false };
      case FETCH_USER_PRODUCT_ALL_GROUPS_SUCCESS:
          return { ...state, productGroups: action.payload.data };
      case FETCH_USER_GROUPS_FAILURE:
          const groupsError = action.payload || { message: action.payload.message };
          return { ...state, groups: [], groupsError: groupsError, groupsIsLoading: false };
      case REQUEST_GROUP_DETAIL:
          return { ...state, groupDetailError: null, groupDetailIsLoading: true };
      case FETCH_GROUP_DETAIL_SUCCESS:
          return { ...state, groupDetail: action.payload.data, groupDetailError: null, groupDetailIsLoading: false };
      case FETCH_GROUP_DETAIL_FAILURE:
          const groupDetailError = action.payload || { message: action.payload.message };
          return { ...state, groupDetail: [], groupDetailError: groupDetailError, groupDetailIsLoading: false };
      case SELECT_CURRENT_GROUP:
          return {...state, currentGroup: action.payload};
      case RESET_CURRENT_USER_GROUP:
          return {...state, currentGroup: null, groupDetail: null};
      case REQUEST_PERMISSIONS:
          return { ...state, permissions: null, permissionsIsLoading: true };
      case FETCH_PERMISSIONS_SUCCESS:
          return { ...state, permissions: action.payload.data, permissionsError: null, permissionsIsLoading: false };
      case FETCH_PERMISSIONS_FAILURE:
          const permissionsError = action.payload || { message: action.payload.message };
          return { ...state, permissions: [], permissionsError: permissionsError, permissionsIsLoading: false };
      case EDIT_USER_DETAIL:
          return { ...state, editUserDetail: null, editUserDetailIsLoading: true };
      case EDIT_USER_DETAIL_SUCCESS:
          return { ...state, editUserDetail: action.payload.data, editUserDetailError: null, editUserDetailIsLoading: false, editUserDetailSuccess: true };
      case EDIT_USER_DETAIL_FAILURE:
          const editUserDetailError = action.payload || { message: action.payload.message };
          return { ...state, editUserDetail: [], editUserDetailError: editUserDetailError, editUserDetailIsLoading: false };
      case EDIT_PASSWORD:
          return { ...state, editPassword: null, editPasswordError: null, editPasswordIsLoading: true, editUserDetailSuccess: false };
      case EDIT_PASSWORD_SUCCESS:
          return { ...state, editPassword: action.payload.data, editPasswordError: null, editPasswordIsLoading: false, editUserDetailSuccess: true };
      case EDIT_PASSWORD_FAILURE:
          const editPasswordError = action.payload.data || { message: action.payload.message };
          return { ...state, editPassword: [], editPasswordError: editPasswordError, editPasswordIsLoading: false };
      case RESET_PASSWORD:
          return {...state, editPasswordError: null, editUserDetailSuccess: false}
      case EDIT_GROUP_DETAIL:
          return { ...state, editGroupDetail: null, editGroupDetailIsLoading: true };
      case EDIT_GROUP_DETAIL_SUCCESS:
          return { ...state, editGroupDetail: action.payload.data, editGroupDetailError: null, editGroupDetailIsLoading: false };
      case EDIT_GROUP_DETAIL_FAILURE:
          const editGroupDetailError = action.payload || { message: action.payload.message };
          return { ...state, editGroupDetail: [], editGroupDetailError: editGroupDetailError, editGroupDetailIsLoading: false };
      case CREATE_GROUP_DETAIL_FAILURE:
          const createGroupDetailError = action.payload || { message: action.payload.message };
          return {...state, createGroupDetailError: createGroupDetailError}
      case RESET_USER_DETAIL:
          return {...state, createUserDetailError: null}
      case CREATE_USER_DETAIL:
          return {...state, createUserDetailError: null}
      case CREATE_USER_DETAIL_SUCCESS:
          return {...state, createUserDetailError: null}
      case CREATE_USER_DETAIL_FAILURE:
          const createUserDetailError = action.payload || { message: action.payload.message };
          return {...state, createUserDetailError: createUserDetailError}
      case CHECK_PASSWORD:
          return { ...state, checkPassword: true, checkPasswordSuccess: false, checkPasswordFailure: false };
      case CHECK_PASSWORD_SUCCESS:
          return { ...state, checkPassword: false, checkPasswordSuccess: true, checkPasswordFailure: false };
      case CHECK_PASSWORD_FAILURE:
          return { ...state, checkPassword: false, checkPasswordSuccess: false, checkPasswordFailure: true };
      case CLEAR_CHECK_PASSWORD:
          return { ...state, checkPassword: false, checkPasswordSuccess: false, checkPasswordFailure: false }
      case CHECK_PERMISSIOIN:
          return { ...state, checkingPermission: true, checkPermissionSuccess: null, checkPermissionFailure: false };
      case CHECK_PERMISSIOIN_SUCCESS:
          return { ...state, checkingPermission: false, checkPermissionSuccess: action.payload.data, checkPermissionFailure: false };
      case CHECK_PERMISSIOIN_FAILURE:
          return { ...state, checkingPermission: false, checkPermissionSuccess: null, checkPermissionFailure: true };
      case REQUEST_ACTION_LOG:
          return {
            ...state,
            actionLog: [],
            actionLogIsLoading: true,
            actionLogError: null,
          };
      case FETCH_ACTION_LOG_SUCCESS:
          return {
            ...state,
            actionLog: action.payload.data,
            actionLogIsLoading: false,
            actionLogError: null,
          };
      case FETCH_ACTION_LOG_FAILURE:
          const actionLogError = action.payload || { message: action.payload.message };
          alert(JSON.stringify(actionLogError));
          return {
            ...state,
            actionLog: [],
            actionLogIsLoading: false,
            actionLogError,
          };
      case REQUEST_ACTION_LOG_BY_FILTER: 
        return {
            ...state, actionLog: [], actionLogIsLoading: true, actionLogError: null,
        };
      case ACTION_LOG_FILTER_SUCCESS:
        return {
            ...state, actionLog: action.payload.data, actionLogIsLoading: false, actionLogError: null,
        }
      case ACTION_LOG_FILTER_FAILURE:
        const actionLogFilterError = action.payload || { message: action.payload.message };
        return {
            ...state, actionLog: [], actionLogIsLoading: false, actionLogError: actionLogFilterError,
        }
      case GRAB_MOBILE_USER_ID: 
        return {
            ...state, mobileUserId: action.payload,
        }
      case REQUEST_USERNAME:
          return {
              ...state, usernameIsLoading: true,
          }
      case REQUEST_USERNAME_SUCCESS:
          return {
              ...state, usernameIsLoading: false, userNameError: null, username: action.payload,
          }
      case REQUEST_USERNAME_FAILURE:
          return {
              ...state, usernameIsLoading: false, userNameError: action.payload,
          }
      case CLEAR_USERNAME_DATA:
          return {
              ...state, username: null, usernameIsLoading: false, userNameError: null, mobileUserId: null,
          }
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./master/jsx/reducers/settings_reducer.jsx